import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/mangas';

interface Props {
  manga: Manga;
  rank?: number;
}

export default function MangaCard({ manga, rank }: Props) {
  return (
    <article className="group" data-product-shop>
      <Link to={`/manga/${manga.id}`} className="block" aria-label={`${manga.title} - 查看详情`}>
        <div className="relative overflow-hidden rounded-lg bg-background-200">
          <img
            src={manga.cover}
            alt={`${manga.title} 封面 - 樱花漫画网${manga.categoryName}在线阅读`}
            title={`${manga.title} - ${manga.categoryName}`}
            className="aspect-[2/3] w-full object-cover object-top transition duration-500 group-hover:scale-105"
          />
          <span
            className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-medium text-background-50 ${
              manga.status === '连载中' ? 'bg-primary-500' : 'bg-secondary-500'
            }`}
          >
            {manga.status}
          </span>
          {rank !== undefined && (
            <span
              className={`absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold text-background-50 ${
                rank <= 3 ? 'bg-accent-500' : 'bg-foreground-800/70'
              }`}
            >
              {rank}
            </span>
          )}
        </div>
        <div className="mt-3">
          <h3 className="truncate text-sm font-semibold text-foreground-900 transition group-hover:text-primary-600 md:text-base">
            {manga.title}
          </h3>
          <div className="mt-1 flex items-center justify-between text-xs text-foreground-500">
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{manga.categoryName}</span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500"></i>
              {manga.rating}
            </span>
          </div>
          <p className="mt-1 truncate text-xs text-foreground-400">更新：{manga.latestChapter}</p>
        </div>
      </Link>
    </article>
  );
}